module.exports = __webpack_public_path__ + "img/BC2E44A9.f30b7abd.jpg";